import withPopover from "Components/withPopover";
import omit from "lodash/omit";
import React from "react";
import { Button } from "../Button";
const ButtonWithPopover = withPopover((props) => (React.createElement(Button, { ...omit(props, ["width", "height"]), height: props.buttonHeight, width: props.buttonWidth })));
export default ButtonWithPopover;
